import React from "react";
import { Link } from "react-router-dom";

const CategoryDetail = ({ categoryProducts }) => {
  const { _id, img, name, price } = categoryProducts;

  return (
    <div className="card card-compact w-80 mx-auto  border-0 hover:scale-105 hover:duration-500 bg-secondary shadow-2xl hover:bg-neutral rounded-md">
      <Link to={`/product/${_id}`} className=" text-accent">
        <figure className="hover:scale-105 hover:duration-500 ">
          <img className="h-80 w-80 p-5" src={img} alt="Shoes" />
        </figure>
        <div class="card-body text-secondary">
          <h2 className="text-sm text-center font-bold text-black">
            {name.slice(0, 100)}
          </h2>
          <p className="text font-bold text-center text-primary">
            Price: {price} Tk
          </p>
        </div>
      </Link>
    </div>
  );
};

export default CategoryDetail;
